import { FaLock } from 'react-icons/fa'
import './index.css'

const CartSummary = props => {
  const {totalItems, totalPrice} = props

  return (
    <>
      <div className="cart-summary-container">
        <h2 className="summary-heading">Order Summary</h2>
        
        <div className="summary-item-row">
          <span className="summary-label">Subtotal ({totalItems} items)</span>
          <span className="summary-value">₹{totalPrice}</span>
        </div>
        
        <div className="summary-item-row">
          <span className="summary-label">Delivery Charges</span>
          <span className="summary-value delivery-free">FREE</span>
        </div>
        
        <div className="summary-item-row">
          <span className="summary-label">Estimated Tax</span>
          <span className="summary-value">Included</span>
        </div>
        
        <hr className="summary-divider" />
        
        <div className="summary-item-row summary-total-row">
          <span className="summary-label-total">Total Bill</span>
          <span className="summary-value-total">₹{totalPrice}</span>
        </div>
        
        <button type="button" className="checkout-button desktop-checkout-button">
          <FaLock className="checkout-lock-icon" /> Proceed to Checkout
        </button>
        
        <p className="trust-indicator desktop-checkout-button">🔒 100% Safe & Secure Payment</p>
      </div>
      
      <div className="mobile-sticky-footer">
        <div className="mobile-sticky-total-container">
          <span className="mobile-total-label">TOTAL AMOUNT</span>
          <span className="mobile-total-value">₹{totalPrice}</span>
          <span className="mobile-total-items">{totalItems} items</span>
        </div>
        <button type="button" className="mobile-checkout-button">
          <FaLock className="checkout-lock-icon" /> Checkout
        </button>
      </div>
    </>
  )
}

export default CartSummary
